/* eslint-disable */
import { tint } from 'polished';
import React, { ReactNode, useEffect, useMemo, useRef } from 'react';
import { Colors } from '../../../ui/Colors';
import { useComponentObserver } from '../../canvas/visualization/ComponentObserver';
import { RenderBounds, usePose } from '../../canvas/visualization/RenderHelpers';
import { Graphic } from '../graphics/Graphic';
import { GraphicTexture } from '../graphics/GraphicTexture';
import { Symbol } from './Symbol';

const hover = tint(.5, Colors.primary);
const active = Colors.primary;

const computeGlowSize = (texture: GraphicTexture) => {
    const { width, height } = texture.image;
    const size = (width + height) / 2;
    if (size < 500) return 4;
    if (size < 1000) return 6;
    return Math.round(Math.log2(size));
};

const usePoseDerivatives = (object: Symbol) => {
    const p = usePose(object);
    return useMemo(() => ({
        highlighted: !!(p.pressed || p.targeted || p.selected) && !p.beingManipulated,
        selected: p.selected,
    }), [p]);
};

const useSilhouette = (object: Symbol) => {
    const first = object.children[0];
    useComponentObserver(first);
    const texture = first?.as(Graphic)?.texture;
    return useMemo(() => texture?.createSilhouette(computeGlowSize(texture)), [texture]);
};

const useSilhouetteGlowOnHighlight = (object: Symbol) => {
    const { highlighted, selected } = usePoseDerivatives(object);
    const silhouette = useSilhouette(object);
    const elmt = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        if (!elmt.current) return;
        if (!silhouette) return;

        if (highlighted || selected) {
            const { width, height } = silhouette;
            elmt.current.width = width;
            elmt.current.height = height;

            const ctx = elmt.current.getContext('2d');
            ctx.drawImage(silhouette, 0, 0);
            ctx.globalCompositeOperation = 'source-in';
            ctx.fillStyle = selected ? active : hover;
            ctx.fillRect(0, 0, width, height);
        }
        else {
            elmt.current?.getContext('2d')?.clearRect(0, 0, elmt.current.width, elmt.current.height);
        }
    }, [elmt.current, silhouette, highlighted, selected]);

    return elmt;
};

export const SymbolVisual = ({ object, children }: { object: Symbol, children: ReactNode }) => {

    const canvasRef = useSilhouetteGlowOnHighlight(object);

    const style = {
        position: 'absolute' as const,
        top: -50,
        left: -50,
        width: object.width + 100,
        height: object.height + 100,
        // backgroundImage: highlighted ? `url(${glow?.toDataURL()})` : undefined,
        // backgroundImage: `url(${glow?.toDataURL()})`,
    };

    return <>
        <RenderBounds object={object}>
            {/* {glow && <div style={style} />} */}
            <canvas ref={canvasRef} style={style} />
        </RenderBounds>
        {children}
    </>;
};